import { render, staticRenderFns } from "./ManagersTable.component.vue?vue&type=template&id=54319471"
import script from "./ManagersTable.component.vue?vue&type=script&lang=ts"
export * from "./ManagersTable.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports